import defaultState from "./state";


const mantenedorSelReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "LOADING_MANTENEDOR_EMPRESA": {
      return Object.assign({}, state, {
        isLoading: action.isLoading,
      });
    }
    case "SET_FILTROS_EMPRESAS": {
      return Object.assign({}, state, {
        filtrosEmpresas: action.filtros,
      });
    }
    case "OPEN_CLOSE_MODAL_ELIMINAR_EMPRESA": {
      return Object.assign({}, state, {
        isOpenModalEliminar: action.isOpen,
        empresa: action.empresa,
      });
    }
    case "OPEN_CLOSE_MODAL_EDITAR_EMPRESA": {
      return Object.assign({}, state, {
        isOpenModalEditar: action.isOpen,
        empresa: action.empresa,
        isNewEmpresa: action.isNew,
      });
    }
    case "SET_LISTA_EMPRESA": {
      return Object.assign({}, state, {
        listaEmpresas: action.data,
        listaEmpresasFiltradas: action.data,
      });
    }
    case "SET_EMPRESA": {
      return Object.assign({}, state, {
        empresa: action.data,
      });
    }
    case "SET_LISTA_EMPRESAS_FILTRADAS": {
      return Object.assign({}, state, {
        listaEmpresasFiltradas: action.lista,
      });
    }
    case "SET_BASE_64_FILE": {
      return Object.assign({}, state, {
        base64file: action.value,
      });
    }
    default:
      return state;
  }
};

export default mantenedorSelReducer;
